import FieldDefs from './BackLinksIpSubnetFieldDefs';
import {doLangFields} from '../../lib/ks-tools';
import BacklinksIpSelector from "./mixins/Selector";

export default {
    template: `<div><slot v-bind="self" /></div>`,
    mixins: [BacklinksIpSelector],
    data() {
        return {
            fields: doLangFields(this, "lang.report.backlinks_ip_subnet.fields", FieldDefs),
            sortOrder: [
                {
                    field: 'domains_count',
                    direction: 'desc'
                }
            ],
            moreParams: {},
            additionalActions: [],
            viewMode: '&subnet=1',
        }
    },
    computed: {
        getApiUrl(){
            return '/report/simple/links/backlinks-ip/subnet?domain=' + this.domain;
        },
        self() {
            return this;
        },
    },
}
